import { useEffect, useRef } from 'react';
import LocomotiveScroll from 'locomotive-scroll';
import 'locomotive-scroll/dist/locomotive-scroll.css';

const LocomotiveScrollComponent = ({ children }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    let scroll = null;
    
    try {
      scroll = new LocomotiveScroll({
        el: scrollRef.current,
        smooth: true,
        multiplier: 0.8,
        class: 'is-revealed',
        smartphone: {
          smooth: true,
          direction: 'vertical',
        },
        tablet: {
          smooth: true,
          direction: 'vertical',
        },
        reloadOnContextChange: true,
        touchMultiplier: 2,
        smoothMobile: true,
        getDirection: true,
      });

      // Validate scroll instance has required methods
      if (!scroll || typeof scroll.update !== 'function') {
        throw new Error('Scroll instance is invalid or missing required methods');
      }

      // Make scroll instance globally available
      window.locomotiveScroll = scroll;

      // Handle resize
      const handleResize = () => {
        try {
          if (scroll && scroll.update && typeof scroll.update === 'function') {
            scroll.update();
          }
        } catch (error) {
          console.warn('Error updating scroll on resize:', error);
        }
      };

      // Handle anchor links
      const handleAnchorClick = (e) => {
        const href = e.target.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          const targetElement = document.querySelector(href);
          if (targetElement && scroll && scroll.scrollTo && typeof scroll.scrollTo === 'function') {
            scroll.scrollTo(targetElement);
          }
        }
      };

      // Update scroll on route changes
      const updateScroll = () => {
        setTimeout(() => {
          try {
            if (scroll && scroll.update && typeof scroll.update === 'function') {
              scroll.update();
            }
          } catch (error) {
            console.warn('Error updating scroll on route change:', error);
          }
        }, 100);
      };

      window.addEventListener('resize', handleResize);
      document.addEventListener('click', handleAnchorClick);
      window.addEventListener('popstate', updateScroll);

      // Initial update
      setTimeout(() => {
        try {
          if (scroll && scroll.update && typeof scroll.update === 'function') {
            scroll.update();
          }
        } catch (error) {
          console.warn('Error on initial scroll update:', error);
        }
      }, 500);

      // Cleanup
      return () => {
        try {
          if (scroll && scroll.destroy && typeof scroll.destroy === 'function') {
            scroll.destroy();
          }
        } catch (error) {
          console.warn('Error destroying scroll instance:', error);
        }
        window.removeEventListener('resize', handleResize);
        document.removeEventListener('click', handleAnchorClick);
        window.removeEventListener('popstate', updateScroll);
        delete window.locomotiveScroll;
      };
    } catch (error) {
      console.error('Error initializing Locomotive Scroll:', error);
      // Fallback to normal scrolling
      window.locomotiveScroll = null;
      
      // Return cleanup function for error case
      return () => {
        delete window.locomotiveScroll;
      };
    }
  }, []);

  return (
    <div ref={scrollRef} data-scroll-container>
      {children}
    </div>
  );
};

export default LocomotiveScrollComponent;
